import Trans from 'components/Trans'
import { VaultKey } from 'state/types'
import { allTokens } from '@pancakeswap/tokens'

export const vaultPoolConfig = {
  [VaultKey.CakeVaultV1]: {
    name: <Trans>Auto HYDX</Trans>,
    description: <Trans>Automatic restaking</Trans>,
    autoCompoundFrequency: 5000,
    gasLimit: 380000n,
    tokenImage: {
      primarySrc: `/images/tokens/all/${allTokens.hydx.address.toLowerCase()}.png`,
      secondarySrc: '/images/autorenew.svg',
    },
  },
  [VaultKey.CakeVault]: {
    name: <Trans>Stake HYDX</Trans>,
    description: <Trans>Stake, Earn – And more!</Trans>,
    autoCompoundFrequency: 5000,
    gasLimit: 1100000n,
    tokenImage: {
      primarySrc: `/images/tokens/all/${allTokens.hydx.address.toLowerCase()}.png`,
      secondarySrc: '/images/autorenew.svg',
    },
  },
  [VaultKey.CakeFlexibleSideVault]: {
    name: <Trans>Flexible HYDX</Trans>,
    description: <Trans>Flexible staking on the side.</Trans>,
    autoCompoundFrequency: 5000,
    gasLimit: 500000n,
    tokenImage: {
      primarySrc: `/images/tokens/all/${allTokens.hydx.address.toLowerCase()}.png`,
      secondarySrc: '/images/autorenew.svg',
    },
  },
  [VaultKey.IfoPool]: {
    name: 'IFO HYDX',
    description: <Trans>Stake HYDX to participate in IFOs</Trans>,
    autoCompoundFrequency: 1,
    gasLimit: 500000n,
    tokenImage: {
      primarySrc: `/images/tokens/all/${allTokens.hydx.address.toLowerCase()}.png`,
      secondarySrc: `/images/ifo-pool-icon.svg`,
    },
  },
} as const
